import { useTranslation } from "react-i18next";
import "./Contact.css";

export default function Contact() {
  const { t } = useTranslation();

  return (
    <div className="contact-page">
      {/* Contact Form Section */}
      <section className="contact-form-section">
        <div className="contact-form-wrapper">
          <div className="contact-form-header">
            <h2 className="contact-form-title">{t("contact.form.title")}</h2>
            <p className="contact-form-subtitle">
              {t("contact.form.subtitle")}
            </p>
          </div>
          <div className="contact-form-container">
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSd8twMg_0wNAIncCHFZ2-ASlMNY8oQ6oHpJIKEO9bpXDfC2fQ/viewform?embedded=true"
              title="Contact Form"
              className="google-form"
            >
              {t("common.loading")}
            </iframe>
          </div>
        </div>
      </section>
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-content">
          <h1 className="contact-hero-title">{t("contact.hero.title")}</h1>
          <p className="contact-hero-subtitle">{t("contact.hero.subtitle")}</p>
          <p className="contact-hero-description">
            {t("contact.hero.description")}
          </p>
        </div>
      </section>

      {/* Contact Information Cards */}
      <section className="contact-info-section">
        <div className="contact-info-grid">
          <div className="contact-info-card">
            <div className="contact-info-icon">
              <span>📧</span>
            </div>
            <h3 className="contact-info-title">
              {t("contact.info.email.title")}
            </h3>
            <p className="contact-info-text">{t("contact.info.email.value")}</p>
          </div>

          <div className="contact-info-card">
            <div className="contact-info-icon">
              <span>🌐</span>
            </div>
            <h3 className="contact-info-title">
              {t("contact.info.website.title")}
            </h3>
            <p className="contact-info-text">
              {t("contact.info.website.value")}
            </p>
          </div>

          <div className="contact-info-card">
            <div className="contact-info-icon">
              <span>📍</span>
            </div>
            <h3 className="contact-info-title">
              {t("contact.info.location.title")}
            </h3>
            <p className="contact-info-text">
              {t("contact.info.location.value")}
            </p>
          </div>

          <div className="contact-info-card">
            <div className="contact-info-icon">
              <span>⏰</span>
            </div>
            <h3 className="contact-info-title">
              {t("contact.info.hours.title")}
            </h3>
            <p className="contact-info-text">{t("contact.info.hours.value")}</p>
          </div>

          <div className="contact-info-card">
            <div className="contact-info-icon">
              <span>🚀</span>
            </div>
            <h3 className="contact-info-title">
              {t("contact.info.telegram.title")}
            </h3>
            <p className="contact-info-text">
              {t("contact.info.telegram.value")}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
